<!--
 * @Author: huanglin.like@qq.com
 * @LastEditTime: 2024-04-19 10:10:58
-->
<template>
  <div>
    <com-page>
      <com-order-search @search="handleSearch" @onExport="handleExport"></com-order-search>
      <com-card>
        <div class="flex items-start mb-5px">
          <h4 class="mt-12px">订单状态</h4>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
              :label="item.label"
              :name="item.value"
              v-for="item in statusTag"
              :key="item.value"
            ></el-tab-pane>
          </el-tabs>
        </div>
        <com-order-list ref="orderListRef" :defaultParams="defaultParams"></com-order-list>
      </com-card>
    </com-page>
  </div>
</template>

<script>
import utils from 'my-tools-library'

export default {
  data() {
    return {
      activeName: '0',
      statusTag: [
        {
          label: '全部',
          value: '0'
        },
        {
          label: '进行中',
          value: '1'
        },
        {
          label: '已完成',
          value: '2'
        },
        {
          label: '已退单',
          value: '3'
        }
      ],
      defaultParams: {
        status: ''
      },
      exportQuery: {}
    }
  },
  methods: {
    handleClick() {
      this.defaultParams.status = +this.activeName === 0 ? '' : +this.activeName + 1

      if (+this.activeName === 3) {
        this.defaultParams.status = 6
      }
      this.$refs.orderListRef.init()
    },
    handleSearch(val) {
      this.exportQuery = { ...val }
      this.$refs.orderListRef.search(val)
    },
    async handleExport() {
      // console.log('handleExport :>> ')
      const params = {
        status: this.defaultParams.status,
        ...this.exportQuery
      }
      const obj = JSON.parse(JSON.stringify(params))
      let i = ''
      let url = ''
      // eslint-disable-next-line prefer-template, guard-for-in, no-restricted-syntax
      for (i in obj) url += '&' + i + '=' + obj[i]
      const downloadUrl = `${process.env.VUE_APP_REQUEST_URL}/chargePieOrder/exportExcel?${url}`
      utils.download(downloadUrl, '订单列表')
    }
  }
}
</script>

<style lang="scss" scoped></style>
